<template>
  <v-form ref="form" v-model="valid">
    <v-card class="pa-3">
      <v-data-table
        :headers="components"
        class="elevation-1"
        :items="logbooksToImportExtension"
        key="id:key"
        :loading="loading"
      >
        <template v-slot:headers="props">
          <tr>
            <th>Entrada válida?</th>
            <th v-for="(header, i) in props.headers" :key="header.text + i">
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr @click="editLog(props.item)">
            <template>
              <td align="center">
                <v-icon v-if="props.item.isValid" small>check</v-icon>
              </td>
              <td
                align="center"
                v-for="(component, i) in components"
                :key="component.id + i"
              >
                <span
                  :class="[
                    props.item[`${component.id}:invalid`]
                      ? 'underlineChanged'
                      : ''
                  ]"
                  >{{
                    props.item.hasOwnProperty(`${component.id}:text`)
                      ? props.item[`${component.id}:text`]
                      : props.item[`${component.id}`]
                  }}</span
                >
              </td>

              <td style="text-align: center">
                <v-btn icon @click.stop="() => editLog(props.item)">
                  <v-icon small>edit</v-icon>
                </v-btn>
              </td>
            </template>
          </tr>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-btn
          @click="importData"
          :disabled="dataIsValid"
          :loading="loading"
          color="success"
          >{{ $t('common.Import') }}</v-btn
        >
        <v-btn flat color="gray" @click="closeMe">{{
          $t('common.Cancel')
        }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="showEditDialog"
      :persistent="true"
      ffullscreen="isMobile"
      max-width="600"
      lazy
    >
      <LogForm
        :key="(logToEdit || {})['id:key']"
        :log-to-edit="logToEdit"
        :close="closeEditLogForm"
        :returnlogbook="updateLogbook"
      />
    </v-dialog>
  </v-form>
</template>

<script>
import { SharedUsers } from '@/models/SharedUsers'
import { mapActions } from 'vuex'
import LogForm from './LogForm'
import { parseValue } from '../../../utils/logUtils'
import * as algolia from '../../../services/algolia.js'
import { TreeDataDictionary } from '../../../models/Specialty'

export default {
  components: { LogForm },
  props: {
    excelHeader: {
      type: Array,
      required: true
    },
    excelLines: {
      type: Array,
      required: true
    },
    components: {
      type: Array,
      required: true
    },
    closeMe: {
      required: true,
      type: Function
    },
    logtype: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      valid: true,
      logToEdit: null,
      showEditDialog: false,
      showOnlyChanged: false,
      logbooksToImport: [],
      loading: true
    }
  },
  computed: {
    logbooksToImportExtension() {
      return this.logbooksToImport.map(l => {
        return { ...l, isValid: this.logIsValid(l) }
      })
    },
    dataIsValid() {
      return this.logbooksToImportExtension.some(l => !l.isValid)
    },
    multipleValuesComponentTypes() {
      return ['multi-select', 'custom-multi-select', 'hint-field-multiple']
    },
    multipleValuesComponent() {
      return ['loco-regional-anesthesia']
    }
  },
  methods: {
    ...mapActions(['addLogs', 'showErrorSnackbar']),
    createUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8
          return v.toString(16)
        }
      )
    },
    logIsValid(l) {
      const keys = Object.keys(l)

      for (let i = 0; i < keys.length; i++) {
        const k = keys[i]
        if (k.includes(':invalid')) {
          const v = l[k]

          if (v) {
            return false
          }
        }
      }

      return true
    },
    closeEditLogForm() {
      this.showEditDialog = false
      this.logToEdit = null
    },
    importData() {
      this.loading = true
      this.logbooksToImport.forEach(logbook => {
        Object.keys(logbook).forEach(key => {
          if (
            key.includes(':changed') ||
            key.includes(':lastValue') ||
            key.includes(':text') ||
            key.includes(':key')
          ) {
            delete logbook[key]
          }
        })
      })

      const logs = this.logbooksToImport.map(log => ({
        ...log,
        userId: this.$store.getters.profile.id,
        specialty: this.$store.getters.user.specialty
      }))

      return this.addLogs(logs)
        .catch(err =>
          this.showErrorSnackbar(err.message || 'Something went wrong')
        )
        .finally(() => {
          this.closeMe()
          this.loading = false

          this.$router.go()
        })
    },
    editLog(log) {
      const logCopy = { ...log }
      this.logToEdit = logCopy
      this.showEditDialog = true
    },
    updateLogbook(updatedLogbook) {
      const indexToReplace = this.logbooksToImport.findIndex(
        log => log['id:key'] === updatedLogbook['id:key']
      )

      const parsedLog = this.parseLog(updatedLogbook)

      this.logbooksToImport.splice(indexToReplace, 1, parsedLog)
    },
    getICD10(value) {
      return algolia.search(
        value,
        'codes_10_cm',
        this.$store.getters.accessToken,
        {}
      )
    },
    getICDO(value) {
      return algolia.search(
        value,
        'codes_o_histology',
        this.$store.getters.accessToken,
        {}
      )
    },
    parseLog(l, parseFromExcelLine = false) {
      const log = parseFromExcelLine ? {} : { ...l }

      let currentIndex = 0

      this.components.forEach(component => {
        if (component.type === 'surgical-autonomy') {
          component.options = [
            {
              $id: 'surgeon',
              component: 'surgical-autonomy',
              text: 'Cirurgião',
              value: 'surgeon'
            },
            {
              $id: 'helper-1',
              component: 'surgical-autonomy',
              text: 'Ajudante 1',
              value: 'helper-1'
            },
            {
              $id: 'helper-2',
              component: 'surgical-autonomy',
              text: 'Ajudante 2',
              value: 'helper-2'
            },
            {
              $id: 'helper-3',
              component: 'surgical-autonomy',
              text: 'Ajudante 3',
              value: 'helper-3'
            },
            {
              $id: 'observer',
              component: 'surgical-autonomy',
              text: 'Observador',
              value: 'observer'
            }
          ]
        }

        let value

        if (
          parseFromExcelLine &&
          (this.multipleValuesComponentTypes.some(
            mvc => mvc === component.type
          ) ||
            this.multipleValuesComponent.some(mvc => mvc === component.id))
        ) {
          const indexes = this.getAllIndexes(this.excelHeader, h =>
            h.startsWith(component.text)
          )

          value = indexes.map(i => l[i]).join(',')
          currentIndex += indexes.length
        } else {
          value = parseFromExcelLine ? l[currentIndex] : l[component.id]
          currentIndex++
        }

        const match = parseValue(value, component, l)

        log[`${component.id}:lastValue`] = value
        // log[`${component.id}:changed`] = value != match.text

        if (!match.valid) {
          log[`${component.id}:invalid`] = match.changed
        }

        log[`${component.id}:text`] = match.text
        log[component.id] = match.value

        if (!log[component.id]) {
          log[`${component.id}:invalid`] = false
        }
      })

      log.logbook = this.logtype

      return log
    },
    getLogsToImport() {
      this.logbooksToImport = this.excelLines.map(line => {
        const l = this.parseLog(line, true)
        const logCopy = { ...l }
        logCopy['id:key'] = this.createUUID()
        return logCopy
      })

      this.loading = false
    },
    getAllIndexes(arr, match) {
      const indexes = []

      arr.forEach((el, index) => {
        if (match(el)) {
          indexes.push(index)
        }
      })

      return indexes
    },
    getICD10Dependencies() {
      return new Promise((resolve, reject) => {
        const icd10Indexes = this.getAllIndexes(this.components, c =>
          ['icd10', 'icd10-sec'].includes(c.type)
        )

        const icd10Values = this.excelLines.flatMap(l =>
          icd10Indexes.map(i => l[i])
        )

        if (icd10Values) {
          Promise.all(icd10Values.map(v => this.getICD10(v))).then(result => {
            let results = result.reduce((acc, v) => {
              acc = [...acc, ...v]
              return acc
            }, [])

            results = results.filter(r => icd10Values.includes(r.code))

            results = results.map(r => ({
              text: r.code,
              value: `${r.code}:${r.long_description_pt}`,
              changed: false
            }))

            icd10Indexes.forEach(i => {
              this.components[i].options = results
            })

            resolve()
          })
        } else {
          resolve()
        }
      })
    },
    getICDODependencies() {
      return new Promise((resolve, reject) => {
        const icdoIndexes = this.getAllIndexes(this.components, c =>
          ['icdo-topography', 'icdo-histology'].includes(c.type)
        )

        const icdoValues = this.excelLines.flatMap(l =>
          icdoIndexes.map(i => l[i])
        )

        if (icdoValues) {
          Promise.all(icdoValues.map(v => this.getICDO(v))).then(result => {
            let results = result.reduce((acc, v) => {
              acc = [...acc, ...v]
              return acc
            }, [])

            results = results.filter(r =>
              icdoValues.includes(r.histology_behavior)
            )

            results = results.map(r => ({
              text: r.histology_behavior,
              value: `${r.histology_behavior}:${r.histology_behavior_description}`,
              changed: false
            }))

            icdoIndexes.forEach(i => {
              this.components[i].options = results
            })

            resolve()
          })
        } else {
          resolve()
        }
      })
    },
    getUserDependencies() {
      return new Promise((resolve, reject) => {
        const userIndexes = this.getAllIndexes(this.components, c =>
          ['autonomy'].includes(c.type)
        )

        SharedUsers.fetch(this.$store.getters.accessToken, [
          this.$store.getters.specialty
        ]).then(() => {
          const results = SharedUsers.query().get()

          userIndexes.forEach(i => {
            this.components[i].options = results
          })

          resolve()
        })
      })
    },
    getTreeDependencies() {
      return new Promise((resolve, reject) => {
        const treeIndexes = this.getAllIndexes(this.components, c =>
          ['multi-select-tree', 'single-select-tree'].includes(c.type)
        )

        treeIndexes.forEach(i => {
          const component = this.components[i]

          let treeFlatData = TreeDataDictionary.query()
            .where('tabName', component.tabName)
            .first().flatTreeData

          component.options = treeFlatData.map(l => ({
            text: l.label,
            value: l.id
          }))
        })

        resolve()
      })
    },
    getDependencies() {
      return new Promise((resolve, reject) => {
        const dependencies = [
          this.components.some(c => ['icd10', 'icd10-sec'].includes(c.type))
            ? this.getICD10Dependencies()
            : null,
          this.components.some(c =>
            ['icdo-topography', 'icdo-histology'].includes(c.type)
          )
            ? this.getICDODependencies()
            : null,
          this.components.some(c => ['autonomy'].includes(c.type))
            ? this.getUserDependencies()
            : null,
          this.components.some(c =>
            ['multi-select-tree', 'single-select-tree'].includes(c.type)
          )
            ? this.getTreeDependencies()
            : null
        ]

        if (dependencies.filter(d => d).length) {
          Promise.all(dependencies).then(() => {
            resolve()
          })
        } else {
          resolve()
        }
      })
    }
  },
  watch: {
    excelLines() {
      this.getDependencies().then(() => {
        this.getLogsToImport()
      })
    }
  }
}
</script>

<style>
.underlineChanged {
  text-decoration: underline;
  color: red;
}
</style>
